import { createSelector } from 'selectors'

import { constant } from './constant'

const getDateInputs = () => createSelector<NodeListOf<HTMLInputElement>>({ selector: constant.selector.inputs }, true)

export const getDatePickerComponents = () => ({
	dateInputs: getDateInputs(),
})
